<!--
// app/components/Shared/icons/KickIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  profileLink?: string;
};

withDefaults(defineProps<Props>(), {
  width: 20,
});
</script>

<template>
  <component
    :is="profileLink ? 'a' : 'span'"
    :href.attr="profileLink"
    :target.attr="profileLink ? '_blank' : undefined"
  >
    <svg :width="width" :height="height" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 0H9.76711V5.79452H12.589V2.82193H15.5616V0H24.1781V8.61645H21.3561V11.589H18.3836V14.411H21.3561V17.3836H24.1781V26H15.5616V23.1781H12.589V20.2055H9.76711V26H1V0Z"
        fill="currentColor"
      />
    </svg>
  </component>
</template>

<style scoped></style>
